import React from "react";
import { Paper, Stack, Typography } from "@mui/material";

export default function StreakBanner({ streakCount = 0, lastStudyDate = null }) {
  return (
    <Paper variant="outlined" sx={{ p: 1.5 }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
        <Typography variant="subtitle2" fontWeight={700}>Streak</Typography>
        <Typography variant="body2">Current: <strong>{streakCount}</strong> day{streakCount === 1 ? "" : "s"}</Typography>
        <Typography variant="caption" color="text.secondary">Last active: {lastStudyDate || "never"}</Typography>
      </Stack>
    </Paper>
  );
}
